import { Component, OnInit } from '@angular/core';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { IFilterParam } from 'src/app/components/grid/IFilterParam';

@Component({
  selector: 'app-exam-schedule-essay-questions',
  templateUrl: './exam-schedule-essay-questions.component.html',
  styleUrls: ['./exam-schedule-essay-questions.component.scss']
})
export class ExamScheduleEssayQuestionsComponent implements OnInit {
  gridName = 'examScheduleEssayQuestionsGrid';
  constructor(private examSchService: ExamScheduleService, private examService: ExamService, private eventService: EventService) { }

  async ngOnInit() {
    GridUtil.setClearGridSelection();
    this.examSchService.selectedSchQuestionId = null;
    const res = await this.examSchService.getExaminationSchedulesQuestions(this.data.tableParams) as [];
    this.data.tableRows = res.slice(1, res.length);
  }

  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [
        {
          fieldName: 'examinationID',
          fieldValue: `${this.examSchService.selectedIds}`,
          queryOperand: QueryOperand['=='],
          static: true
        },
        {
          fieldName: 'examNo',
          fieldValue: `${this.examSchService.selectedSchedules[0]?.examNo}`,
          queryOperand: QueryOperand['=='],
          static: true
        }
      ],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Examination Schedule Question ID',
      fieldName: 'examinationScheduleQuestionID',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Candidate Answer',
      fieldName: 'candidateAnswer',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Attempt',
      fieldName: 'attempt',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    }
  ];

  onRowClick(idx: any) {
    if (!this.data?.tableRows) { //Just in case tableRows might still not be ready
      setTimeout(() => this.onRowClick(idx), 50);
      return;
    }
    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedScheduleEssayQuestion: any[] = idx.map(x => this.data.tableRows[x]).filter(Boolean);
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedScheduleEssayQuestion.map(x => x.id);
    GridUtil.setRowCliclk(this.gridName, idx, selectedDataRowsId);
  }

  async refreshData(tableParams) {
     if (this.examService.selectedExamIds?.[0] && !tableParams.filterParams.find(f => f.fieldName == 'examinationID')) {
      var filter: IFilterParam =
      {
        fieldName: 'examinationID',
        fieldValue: `${this.examService.selectedExamIds?.[0]}`,
        queryOperand: QueryOperand['=='],
        static: true
      }

      tableParams.filterParams.push(filter);
    }
    const res = await this.examSchService.getExaminationSchedulesQuestions(tableParams) as [];
    if (!res || res.length === 0) {
      return;
    }
    this.data.tableRows = res.slice(1, res.length);
    this.data.tableRows = res.slice(1, res.length);
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

}
